<template>
  <div class="subject">
    <img class="suject-img1" src="../assets/left.png" alt="" />
    <img class="suject-img2" src="../assets/right.png" alt="" />
    <!-- 列表 -->
    <div class="subject-linear">
        <!--底部列表 Start-->
        <lisT />
        <!--底部列表 end-->
    </div>
    <!-- 人员 -->
    <div class="suject-caozuo">
      <div class="suject-caozuo-suject">
        <div class="suject-caozuo-left">报警<br />确认</div>
        <div class="suject-caozuo-right">
          <p>当前用户 &nbsp; <span>1255487/79884</span></p>
          <div class="caozuo-img">刘峰</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import list from "./list.vue";
import lisT from "./list.vue";
export default {
  components: { list },
  name: "subject",
  data() {
    return {};
  },
  components: {
    lisT,
  },
};
</script>
<style lang="less" scoped>
.subject {
  width: 91%;
  height: 18vh;
  position: absolute;
  bottom: 5vh;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  // border: 1px solid red;
  .Zindex();
  background-image: url("../assets/x.png");
  background-size: 90% auto;
  background-position-x: center;
  background-repeat: no-repeat;
  .suject-img1 {
    width: auto;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
  .suject-img2 {
    width: auto;
    height: auto;
    position: absolute;
    right: 0;
    top: 0;
  }
  .subject-linear {
    width: 80%;
    height: 90%;
    // border: 1px solid red;
    margin-left: 1vw;
    margin-top: 1%;
    overflow: auto;
    &::-webkit-scrollbar {
      width:5px;
      height: 5px;

    }
    /* 滚动槽 */
    &::-webkit-scrollbar-track {
      -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
      border-radius:10px;
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius:10px;
      background:rgba(0,0,0,0.1);
      -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
    }
    &::-webkit-scrollbar-thumb {
      background:#fff;
    }
  }
  .suject-caozuo {
    width: 18%;
    height: 100%;
    .displaY();
    .suject-caozuo-suject {
      width: 90%;
      height: 80%;
      border: 1px solid;
      border-color: rgb(200, 255, 250);
      background-color: rgba(0, 63, 80, 0.302);
      .displaY(@justifY:space-around);
      .suject-caozuo-left {
        width: 18%;
        height: 80%;
        border-width: 1px;
        border-style: solid;
        background-color: rgba(246, 159, 45, 0.2);
        border-color: rgb(246, 159, 45);
        color: #fff;
        font-size: 0.8vw;
        .displaY();
      }
      .suject-caozuo-right {
        width: 70%;
        height: 80%;
        border-width: 1px;
        border-color: rgb(0, 255, 234);
        border-style: solid;
        background-color: rgba(0, 255, 234, 0.102);
        .displaY(@justifY:center);
        flex-direction: column;
        p {
          margin-left: 1vw;
          color: rgb(0, 255, 234);
          display: flex;
          align-items: center;
          font-size: 0.8vw;
          span {
            font-size: 0.1vw;
            color: rgb(0, 255, 234);
          }
        }
        .caozuo-img {
          width: 50%;
          height: 55%;
          //   border: 1px solid red;
          background-image: url("../assets/back.png");
          background-size: 100% auto;
          background-repeat: no-repeat;
          margin-top: 2vh;
          .displaY();
          font-size: 1.3vw;
          color: #fff;
          font-family: "SOURCEHANSANSCN-REGULAR";
          margin-top: 1vh;
        }
      }
    }
  }
}
</style>